import { render, staticRenderFns } from "./VDSLiveStatus.vue?vue&type=template&id=ad8582da&scoped=true"
import script from "./VDSLiveStatus.vue?vue&type=script&lang=js"
export * from "./VDSLiveStatus.vue?vue&type=script&lang=js"
import style0 from "./VDSLiveStatus.vue?vue&type=style&index=0&id=ad8582da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8582da",
  null
  
)

/* custom blocks */
import block0 from "./VDSLiveStatus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports